<template>
  <div class="item-inner" style="height: 4rem">
    <div class="item-title label" v-if="attribute.sorteditAble === false" style="width: 60%; color: #8e8e93;" >选择靶点</div>
    <div class="item-title label" v-else style="width: 54%;">
      选择靶点
      <a class="alert-text" @click="displayMessage(attribute.description)" v-if="attribute.description">
        <img :src="questionUrl" style="width: .9rem"></img>
      </a>
    </div>
    <div class="item-input" v-if="!attrValueDisplay">
      <input type="text"  placeholder="请选择"  v-if="attribute.sorteditAble === false"  :value='attribute.value' disabled="disabled" >
      <input type="text" @click="showOptionList(attribute)" placeholder="请选择"  style="font-size: smaller;margin-left: 0.1rem;height: 1rem" v-else   v-model="attribute.value"  readonly="readonly">
      <!--<div v-for="(arr,index) in attrValueDisplay" v-if=" index !== 1" style="font-size: smaller;margin-left: 0.5rem;">{{arr}}</div>-->
    </div>
    <div class="item-input" v-else>
      <div v-for="(arr,index) in attrValueDisplay" style="font-size: smaller;margin-left: 0.5rem;" @click="showOptionList(attribute)" readonly="readonly">{{arr}}</div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import Emkt from '../../emkt'
  export default {
    name: 'attr-text-box',
    data () {
      return {
        checkedData: '',
        questionUrl: '/emktResources/resocurces/img/question.png'
      }
    },
    props: [
      'attribute', 'index', 'curAttrsInGroup'
    ],
    mounted () {
    },
    created () {
    },
    computed: {
      attrValueDisplay () {
        if (this.attribute.value !== '') {
          let valArr = this.attribute.value.split('|$|')
          console.log('attrValueDisplay----->', valArr)
          if (valArr.length > 1) {
            return valArr
          }
          return this.attribute.value.split('|$')
        }
        return undefined
      }
    },
    methods: {
      getAfterText (attribute) {
        this.attribute.options = Emkt.getLocalStorage('target')
        var ret1 = '<li class="item-content item-link"><label class="label-checkbox item-content">' +
          '<input type="checkbox" class="checkbox-input-attr" style="font-size: smaller"  name="attr" value="'
        var ret2 = ''
        var ret3 = '"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">'
        var ret4 = '"checked="checked"><div class="item-media" style="margin-left: -1rem;"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">'
        let attr = this.attribute.options
        let height = ''
        var length = 0
        let data = []
        for (var k = 0; k < attribute.valueText.split('|$').length; k++) {
          if (attribute.valueText.split('|$')[k] !== '') {
            data.push(attribute.valueText.split('|$')[k])
          }
        }
        for (var key in attr) {
          console.log(data)
          if (data[key] === attr[key]) {
            ret2 += ret1 + key + ret4 + attr[key] + '</div></div></label></li>'
          } else {
            ret2 += ret1 + key + ret3 + attr[key] + '</div></div></label></li>'
          }
          length++
        }
        var ret
        if (length <= 7) {
          height = 2.1 * length + 1
          ret = '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">'
        } else {
          ret = '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">'
        }
        ret = ret + ret2 + '</ul></div></div>'
        return ret
      },
      displayMessage (val) {
        if (!val) {
          return
        }
        $.alert(val)
      },
      getTitle (attribute) {
        return attribute.label
      },
      showOptionList (attribute) {
        console.log(attribute)
        let _this = this
        $.modal({
          title: _this.getTitle(attribute),
          afterText: _this.getAfterText(attribute),
          buttons: [
            {
              text: '取消',
              bold: true,
              onClick: function () {
                if (_this.checkedData) {
                  _this.attribute.value = _this.checkedData
                }
              }
            },
            {
              text: '完成',
              bold: true,
              onClick: function () {
                let val = ''
                let radio = $('.checkbox-input-attr')
                for (var i = 0; i < radio.length; i++) {
                  if (radio[i].checked) {
                    let selectedVal = _this.attribute.options[radio[i].value]
                    val = val === '' ? selectedVal : val + '|$' + selectedVal
                    console.log('selected value --------')
                  }
                }
                if (_this.attribute.value !== val) {
                  _this.attribute.value = val
//                  let data = []
//                  data = val.split(' ')
//                  let l = data[0]
//                  for (var j = 1; j < data.length; j++) {
//                    if (data[j] !== ' ') {
//                      l = l + ' ' + _this.attribute.options[data[j]]
//                    }
//                  }
                  _this.attribute.valueText = val
                  _this.checkedData = val
//                  _this.valueChanged(attribute)
                }
                if (_this.checkedData) {
                  _this.attribute.value = _this.checkedData
                }
                $.closeModal()
              }
            }
          ]
        })
      },

      valueChanged (attribute) {
        this.$emit('controlForm', this.index, this.curAttrsInGroup, attribute)
//        this.$emit('judgeValue', this.curAttrsInGroup, this.index)
      }
//      ,
//      getKeyByValue (value) {
//        let obj = this.attribute.options
//        for (var prop in obj) {
//          if (obj.hasOwnProperty(prop)) {
//            if (obj[prop] === value) {
//              return prop
//            }
//          }
//        }
//      }
    },
    watch: {
      'attribute.value': function (val) {
        this.$emit('controlForm', this.index, this.curAttrsInGroup, val)
      }
//      ,
//      attribute: {
//        handler: function (val) {
//          this.attribute.value = this.getKeyByValue(val)
//        },
//        deep: true
//      }
    }
  }
</script>

<style scoped>
  input {
    border: 1px solid #ccc;
    outline: 0;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  }
  .error input {
    border-color: rgba(246, 58, 56, .8);
    box-shadow: 0 0 8px rgba(246, 58, 56, .6);
  }
  .modal-class{
    width: 12rem;
    height: 15rem;
    margin-top: 1rem;
    margin-left: -3rem;
  }

</style>



// WEBPACK FOOTER //
// TargetChoose.vue?a8eb1032